import { render, staticRenderFns } from "./PaletteFab.vue?vue&type=template&id=7380a94a&lang=pug&"
import script from "./PaletteFab.vue?vue&type=script&lang=js&"
export * from "./PaletteFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaletteFab.vue"
export default component.exports